import { getCsrfToken } from "@/lib/csrf"

/** GET за JSON вне Inertia. */
export function acceptJsonHeaders(): HeadersInit {
  return {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  }
}

/** Запрос с CSRF без JSON-тела: DELETE без тела или FormData (Content-Type ставит браузер). */
export function csrfHeaders(): HeadersInit {
  return {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-Token": getCsrfToken(),
  }
}

export function jsonHeaders(): HeadersInit {
  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-Token": getCsrfToken(),
  }
}

/** Тело ответа как T; при !ok — Error с `error` сервера или `HTTP <status>`. */
export async function handleJson<T>(res: Response): Promise<T> {
  const data = (await res.json().catch(() => ({}))) as { error?: string }
  if (!res.ok) throw new Error(data.error ?? `HTTP ${res.status}`)
  return data as T
}

export async function getJson<T>(url: string): Promise<T> {
  const res = await fetch(url, {
    credentials: "same-origin",
    headers: acceptJsonHeaders(),
  })
  return handleJson<T>(res)
}

/** JSON-запрос с изменением; authenticity_token дописывается в конец тела. */
export async function sendJson<T>(
  method: "POST" | "PATCH" | "DELETE",
  url: string,
  body: Record<string, unknown> = {},
): Promise<T> {
  const res = await fetch(url, {
    method,
    credentials: "same-origin",
    headers: jsonHeaders(),
    body: JSON.stringify({ ...body, authenticity_token: getCsrfToken() }),
  })
  return handleJson<T>(res)
}
